import { SanitiserEventCallback } from "../../types/SanitiserEventCallback";
import { globalAnchorTransform } from "./GlobalAnchorTransform.const";

export const globalAnchorSanitiseEventHandler: SanitiserEventCallback = (element) => {
    if (element.nodeName === "A") {
        globalAnchorTransform.transform(element as HTMLAnchorElement);
    }
};
